import styled from 'styled-components';

interface ContentProps {
  isActive: boolean;
}

interface BtnContribProps {
  isActive: boolean;
}

interface TesteProps {
  isActive: boolean;
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  form {
    width: 100%
  }

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`;

export const Toggle = styled.div`
  display: flex;

  span{
    padding-left: 4px;
    font-size: 12px;
  }
`

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: ${props => props.isActive ? '100%' : '0px'};

  opacity: ${props => props.isActive ? 1 : 0};
  pointer-events: ${props => props.isActive ? 'initial' : 'none'};
  transition: opacity 0.3s ease-in-out;

  h3 {
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 16px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }
`

export const BoxValue = styled.div`
  width: 100%;

  background:#FFF;
  text-align: center;
  margin-bottom: 12px;
  padding: 10px;

  border-radius: 4px;
  border: 1px solid #F4F6F5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  > p {
    font-weight: 600;
    color: ${ props => props.theme.colors.greyDarker};
    padding-bottom: 4px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    height: 35px;

    input {
      color: ${props => props.theme.colors.mainColor};
      font-size: 24px;
      font-weight: 600;
      border: none;
      text-align: center
    }

    input#years {
      width: 50px;

      ::placeholder{
        color: ${props => props.theme.colors.grey03};
      }
    }

    > p {
      color: ${props => props.theme.colors.mainColor};
      font-size: 24px;
      font-weight: 600;
    }

    > small {
      color: ${props => props.theme.colors.grey04};
      font-size: 12px;
    }
  }

  > div#contribution {
    height: 45px;
    flex-direction: column;
  }

`

export const InfoBox = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;

  overflow: none;
  margin-bottom: 10px;
  padding: 5px 12px 8px;

  background: #FFF;
  border-radius: 4px;
  border: 1px solid #F4F6F5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);


  > div.placeholder {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    font-size: 14px;

    small {
      letter-spacing: 0.1em;
      font-weight: 550;
      margin: 4px 0;
      color: ${props => props.theme.colors.grey02}
    }

    svg {
      margin-left: 5px;
      color: ${props => props.theme.colors.warning};
      cursor: pointer;
      position: relative;
    }
  }

  .inputReg {
    padding: 0;
    border: none;
  }
`
export const RadioButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position:relative;

  width: 100%;
  padding: 10px 12px 5px;
  transition: .2s;

  > label {
    transform: translateY(-12px);
    font-size: 14px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    margin: 0 auto;
  }

  @media screen and (max-width: 700px) {
    padding: 10px 5px 5px;

    > div {
      justify-content: space-evenly;
    }
  }
`

export const BtnContrib = styled.button<BtnContribProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 2px solid ${props => props.isActive? props.theme.colors.mainColor : '#DEE3E1'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
  background-color: #FFF ;

  padding: 8px 60px;

  font-size: 16px;
  color: ${props => props.isActive? props.theme.colors.mainColor : '#8E9191'};

  &:disabled {
    cursor: not-allowed;
    background-color: #bababa;
    color: ${({ theme }) => theme.colors.whiteDarker};
    border: 1px solid #EAEAEA;
  }

  &:focus {
    text-decoration: underline;
  }

`

export const ToggleDiv = styled.div`
  background-color: ${({ theme }) => theme.colors.whiteDarker};
  width: 100%;
  border-radius: 15px;
  height: 30px;
  margin: 12px 12px 20px 12px;
`
export const ToggleButton = styled.button<TesteProps>`
  background-color: ${props => props.isActive ? props.theme.colors.mainColor : 'transparent'};
  color: ${props => props.isActive ? props.theme.colors.whiteDarker : props.theme.colors.greyDarker};
  cursor: pointer;
  height: 30px;
  border-radius: 15px;
  width: 50%;
  border: none;
`
